import { get, titleCase } from "sites-common/utils/lodash";
import {
  queryTrainers,
  trainersConfig,
  postprocessTrainers,
  trainersSelectors,
  validateTrainers,
} from "../../common1/firebase-selectors/trainers";
import RenderColumns from "./renderItemCard";
import { trainersCareAppUrl, homeCareAppUrl } from "../../care-app/urls";
import { saveSettings } from "../../common1/firebase-selectors/settings";

const Config = (i_am_admin = false) => {
  const pSelectors = trainersSelectors();

  return {
    primaryKey: trainersConfig.primaryKey,

    disableEditPrimaryKey: true,

    initialQueries: [queryTrainers()],

    homeUrl: trainersCareAppUrl,
    backUrl: homeCareAppUrl,

    sessionKey: "careapp.trainers",
    noItemMsg: "No Trainers Loaded",
    mainTitle: "Trainers",
    mainTitleIcon: "WebAppBuilderFragment",

    pageOptions: {
      "All Trainers": {
        optionsSelector: (/* state */) => [
          { key: "all", text: "All Trainers" },
        ],
        pageSelector: pSelectors.ordered,
      },
    },

    singleItemSelector: pSelectors.id,
    singleItemDispatcher: null,

    collection: trainersConfig.collection,
    postprocess: postprocessTrainers,
    validate: validateTrainers,
    formFields: trainersConfig.fields,
    formDefaults: trainersConfig.defaults,
    postSave: ({ dbStore }) => {
      dbStore.getSnapshot(trainersConfig.collection).then((snapshot) => {
        const trainersMap = {};
        snapshot.forEach((doc) => {
          const data = doc.data();
          if (
            data &&
            (data?.inactive === false || data?.inactive === undefined)
          ) {
            const typeValue = get(data, "type", []);
            trainersMap[doc.id.toLowerCase()] = `${titleCase(
              data.city ? data.city : "NA"
            )} ~ ${titleCase(data.name ? data.name : "NA")} [${
              Array.isArray(typeValue) ? typeValue.join(",") : typeValue || ""
            }]`;
          } else {
            trainersMap[doc.id.toLowerCase()] = false;
          }
        });
        saveSettings(dbStore, { trainersMap });
      });
    },

    editBtnText: "View / Edit Details",
    newBtnText: i_am_admin ? "New" : null,

    panelForNewItem: true,
    panelForEditItem: true,

    renderItemCard: null,
    colDefns: RenderColumns(trainersConfig.primaryKey),
    showTableHeader: true,
    displayAsTable: true,
    tableEditButtonProps: i_am_admin ? { text: "Edit" } : null,

    filterProps: {
      placeholder: "Name / City / Email / State",
      searchFunction: (r) =>
        `${r.name} ${r.city} ${r.email} ${r.country} ${r.state}`,
      filterMenuItems: [
        {
          key: "name",
          text: "Name (Ascending)",
          f: (a, b) => a.name.toLowerCase() > b.name.toLowerCase(),
        },
        {
          key: "cancer",
          text: "Cancer Trainers",
          f: (a, b) =>
            get(a, "name", "").toLowerCase() > get(b, "name", "").toLowerCase(),
          sf: (r) => r.type && r.type.includes("C"),
        },
        {
          key: "mh",
          text: "MH Trainers",
          f: (a, b) =>
            get(a, "name", "").toLowerCase() > get(b, "name", "").toLowerCase(),
          sf: (r) => r.type && r.type.includes("MH"),
        },
        {
          key: "other",
          text: "Other Trainers",
          f: (a, b) =>
            get(a, "name", "").toLowerCase() > get(b, "name", "").toLowerCase(),
          sf: (r) => r.type && r.type.includes("O"),
        },
        {
          key: "city",
          text: "City (Ascending)",
          f: (a, b) =>
            get(a, "city", "").toLowerCase() > get(b, "city", "").toLowerCase(),
        },
        {
          key: "city_d",
          text: "City (Descending)",
          f: (a, b) =>
            get(a, "city", "").toLowerCase() <=
            get(b, "city", "").toLowerCase(),
        },
        {
          key: "email",
          text: "Email (Asscending)",
          f: (a, b) =>
            get(a, "email", "").toLowerCase() >
            get(b, "email", "").toLowerCase(),
        },
      ],
    },
  };
};

export default Config;
